import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionEdu = props => {
  return (
    <Hoc>
      <CvItem date1="2020" date2="2021" imgSrc="FS-Logo.png" id="edu-fs">
        <CvItemDesc
          descBold="Frankfurt School of Finance & Management"
          descNormal="Frankfurt,&nbsp;Germany"
          descComment=""
          imgSrc=""
        />
        <CvItemDetail primary={true} bold={true}>
          Master of Business Administration (MBA) - Candidate
        </CvItemDetail>
        <CvItemDetail bold> EBP Master Thesis (Entrepreneurial Business Plan) </CvItemDetail>
        {/* <CvItemDetail> Lean Start-up Bootcamp </CvItemDetail> */}
        <CvItemDetail bold> Electives in Managment Track: </CvItemDetail>
        <CvItemDetail> Organisational Design </CvItemDetail>
        <CvItemDetail> Lean Start-up Bootcamp </CvItemDetail>
        <CvItemDetail> Agile Management </CvItemDetail>
        <CvItemDetail> New Product Development </CvItemDetail>
        <CvItemDetail> Managing Digitalization </CvItemDetail>
      </CvItem>

      <CvItem date1="2011" date2="2013" imgSrc="TUDLogo3.png" id="edu-delft">
        <CvItemDesc
          descBold="TU Delft, Faculty of Architecture"
          descNormal="Delft,&nbsp;Netherlands"
          descComment=""
          imgSrc=""
        />
        <CvItemDetail primary={true} bold={true}>
          Master of Architecture (MSc)
        </CvItemDetail>
        <CvItemDetail> SADD Studio, UN Environmental Council (&nbsp;MSc&nbsp;Graduation&nbsp;Thesis&nbsp;) </CvItemDetail>
        <CvItemDetail> Hyperbody Studio (&nbsp;MSc&nbsp;2nd&nbsp;Semester&nbsp;) </CvItemDetail>
        <CvItemDetail> Hybrid Buildings Studio (&nbsp;MSc&nbsp;1st&nbsp;Semester&nbsp;) </CvItemDetail>
      </CvItem>

      <CvItem date1="2004" date2="2010" imgSrc="university of tehran.jpg" id="edu-tehran">
        <CvItemDesc
          descBold="University of Tehran, Faculty&nbsp;of&nbsp;Fine&nbsp;Arts"
          descNormal="Tehran,&nbsp;Iran"
        />
        <CvItemDetail primary={true} bold={true}>
          Bachelor of Architecture (&nbsp;BA&nbsp;)
        </CvItemDetail>
        <CvItemDetail> Niavaran Music Center (&nbsp;BA&nbsp;Graduation&nbsp;Thesis&nbsp;) </CvItemDetail>
      </CvItem>
    </Hoc>
  );
};

export default cvSectionEdu;